// MW supplies editorial shelf names without a dedicated presentation type.
export function getShelfPresentation(label) {
  const name = String(label?.name || label?.title || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ı/g, "i")
    .replace(/\s+/g, " ");

  if (/^(en iyi 10|top ?10)(\s|$)/.test(name)) return "ranked";
  if (["cok yakinda", "yakinda", "coming soon"].includes(name))
    return "carousel";
  return "default";
}
